// extracted by mini-css-extract-plugin
export default {"address":"style_address__XYRV+","address1":"style_address1__snD4P","address2":"style_address2__uA1BX","city":"style_city__W1Kep","zip":"style_zip__R2tJ4"};